import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e4bba54"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-auto subtitle" }, "…Raymond 30 Out.", -1))
const _hoisted_2 = { class: "controls" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "FREQUENCY", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "REPEAT", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" TRANSMIT ")

import { BrainViewModel } from '../../../../ecs/brains/Brain';
import IconComponent from '../../../icon/IconComponent.vue';
import DropdownComponent from '@/components/DropdownComponent.vue';
import Icon from '@/components/icon/Icon';
import ButtonComponent from '../../../ButtonComponent.vue';
import BuildableDialogueBodyWidget from '../buildableDialog/BuildableDialogueBodyWidget.vue';
import RepeatsIncrementer from '@/components/system/components/giantVoice/RepeatsIncrementer.vue';
import { computed, ref, Ref } from 'vue';
import {
  BuildableDialogItem,
  RadioBroadcastPayload
} from '../../../../models/BuildableDialogItem';
import { DropdownOptions } from '../../../../models/Forms/FormOptions';


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioControlComponent',
  props: {
    brain: null,
    timeOnActiveCall: null
  },
  emits: ['submit', 'hangup'],
  setup(__props: any, { emit }) {

const props = __props as {
  brain: BrainViewModel;
  timeOnActiveCall: {
    minutes: string;
    seconds: string;
    secondsRaw: number;
    minutesRaw: number;
  };
}



const instantiateAvailableDialog = () => {
  const availableDialog: BuildableDialogItem[] = [];
  props.brain.options.forEach((edge) => {
    if (edge.isVisible) {
      availableDialog.push({ textValue: edge.dialog });
    }
  });
  return availableDialog;
};



const repeats: Ref<number> = ref(0);
const frequency: Ref<string> = ref('');
const dropdownValues: DropdownOptions[] = [
  { label: 'Flightline' },
  { label: 'General' },
  { label: 'Tower' },
  { label: 'Channel 7' }
];

const incrementRepeatsUp = () => {
  repeats.value++;
};

const incrementRepeatsDown = () => {
  if (repeats.value <= 0) {
    return;
  }
  repeats.value--;
};

const builtDialogMessage: Ref<BuildableDialogItem[]> = ref([]);

const failed = false;

const failingResponse = 'Declined call';

const builtMessageBroadcast = computed(() => {
  const message: RadioBroadcastPayload = {
    message: builtDialogMessage.value.map((item) => item.textValue).join(' '),
    repeats: repeats.value,
    frequency: frequency.value
  };
  return message;
});

const reply = () => {
  if (failed) {
    emit('submit', failingResponse);
  } else {
    emit('submit', JSON.stringify(builtMessageBroadcast.value));
  }
  clearBuiltDialog();
};

function addDialogToBuiltDialogMessage(dialogItem: BuildableDialogItem) {
  builtDialogMessage.value.push({ ...dialogItem });
}

function removeDialog(index: number) {
  builtDialogMessage.value.splice(index, 1);
}

function clearBuiltDialog() {
  builtDialogMessage.value = [];
  repeats.value = 0;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(BuildableDialogueBodyWidget, {
      "available-dialog": instantiateAvailableDialog(),
      builtDialogMessage: builtDialogMessage.value,
      onAddDialog: addDialogToBuiltDialogMessage,
      onClear: _cache[3] || (_cache[3] = ($event: any) => (builtDialogMessage.value = [])),
      onRemoveDialog: removeDialog
    }, {
      subtitle: _withCtx(() => [
        _hoisted_1
      ]),
      controls: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _hoisted_3,
            _createVNode(DropdownComponent, {
              class: "w-48",
              placeholder: "Select Option",
              modelValue: frequency.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((frequency).value = $event)),
              values: dropdownValues,
              isClearable: false,
              "left-icon-value": _unref(Icon).CLOCK_EMPHASIZED
            }, null, 8, ["modelValue", "left-icon-value"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_4,
            _createVNode(RepeatsIncrementer, {
              modelValue: repeats.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((repeats).value = $event)),
              onOnLeftSelect: incrementRepeatsDown,
              onOnRightSelect: incrementRepeatsUp
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(ButtonComponent, {
            class: "self-center h-full mt-7 w-42",
            "data-testid": "clear-button",
            "color-type": "tertiary",
            disabled: builtDialogMessage.value.length == 0,
            size: "large",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (builtDialogMessage.value.length > 0 && reply()))
          }, {
            default: _withCtx(() => [
              _createVNode(IconComponent, {
                icon: _unref(Icon).PLAY,
                class: "mr-2"
              }, null, 8, ["icon"]),
              _hoisted_5
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["available-dialog", "builtDialogMessage"])
  ]))
}
}

})